import AuthService from '../../utilities/services/auth.service'
import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'
import { CompIntelligenceWrapper } from '../../components'

export default function CompIntelligencePage() {
  const organization = AuthService.getOrg()[0]

  return (
    <ModalProvider>
      <CompIntelligenceWrapper organization={organization} />
    </ModalProvider>
  )
}
